import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { Leilao } from "src/app/model/leilao.model";
import { ProtocoloArquivo } from "src/app/model/protocolo-arquivo.model";
import { ResultadoPaginado } from "src/app/model/resultado";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

export class FiltroCotistas {
  texto?: string;
  pagina?: number = 1;
  limite?: number = 10;
}

@Injectable({
  providedIn: "root",
})
export class LeilaoService extends FgiBackEndService<Leilao> {

  private readonly urlLeilao = 'front/leiloes';
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return "front/protocolos-arquivos";
  }

  getProtocolosLeiloesEnviados(
    params?: any,
    options?: any
  ): Observable<ResultadoPaginado<ProtocoloArquivo>> {
    return this.http
      .get(this.BASE_URL, { params: params })
      .pipe(catchError(this.handleError)) as Observable<
      ResultadoPaginado<ProtocoloArquivo>
    >;
  }

}
